import { render, staticRenderFns } from "./index.vue?vue&type=template&id=66802a69&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=66802a69&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66802a69",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HomeBannerTop: require('D:/Project/kpwebsite/PC/components/home/bannerTop.vue').default,HomeCommonTitle: require('D:/Project/kpwebsite/PC/components/home/commonTitle.vue').default,MoreLink: require('D:/Project/kpwebsite/PC/components/moreLink/index.vue').default})
